import { render, staticRenderFns } from "./SubpageReport.vue?vue&type=template&id=2681874f&scoped=true&"
import script from "./SubpageReport.vue?vue&type=script&lang=js&"
export * from "./SubpageReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2681874f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2681874f')) {
      api.createRecord('2681874f', component.options)
    } else {
      api.reload('2681874f', component.options)
    }
    module.hot.accept("./SubpageReport.vue?vue&type=template&id=2681874f&scoped=true&", function () {
      api.rerender('2681874f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/billingpayment/SubpageReport.vue"
export default component.exports